<template>
  <div class="dynamic-container">
    <template v-if="data.length">
      <div v-for="(item, index) in data" :key="index" class="dynamic-item">
        <div class="avatar">
          <svg t="1653874359058" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29294" width="100%" height="100%"><path d="M222.304 64h579.392l10.784 0.16 9.888 0.32 9.024 0.512c25.824 1.76 41.056 5.76 54.4 11.776l4.384 2.08 4.352 2.24c20.864 11.136 37.216 27.52 48.384 48.384l2.24 4.32 2.08 4.384c5.664 12.608 9.536 26.88 11.424 50.24l0.576 8.576 0.256 4.608 0.32 9.92 0.16 10.784 0.032 5.76v567.84l-0.096 11.296c0 1.792-0.064 3.552-0.096 5.28l-0.32 9.888-0.512 9.024c-1.76 25.824-5.76 41.056-11.744 54.4l-2.08 4.384-2.24 4.352a116.32 116.32 0 0 1-48.384 48.384l-4.352 2.24-4.384 2.08c-12.608 5.664-26.88 9.536-50.208 11.424l-8.608 0.576-4.608 0.256-9.888 0.32-10.784 0.16-5.76 0.032H228.032l-11.296-0.096c-1.792 0-3.552-0.064-5.28-0.096l-9.888-0.32-8.992-0.512c-25.856-1.76-41.088-5.76-54.4-11.744l-4.416-2.08-4.32-2.24a116.32 116.32 0 0 1-48.384-48.384l-2.24-4.352-2.08-4.384c-5.696-12.608-9.568-26.88-11.456-50.208l-0.576-8.608a411.36 411.36 0 0 1-0.224-4.608l-0.32-9.888L64 801.696V222.304l0.16-10.816 0.32-9.888 0.512-8.992c1.76-25.856 5.76-41.088 11.776-54.4l2.08-4.416 2.24-4.32a116.32 116.32 0 0 1 48.384-48.384l4.32-2.24 4.384-2.08c12.608-5.696 26.88-9.568 50.24-11.456l8.576-0.576 4.608-0.224 9.92-0.32L222.272 64z" fill="#9A89FF" p-id="29295"></path><path d="M508.064 352h7.872c6.592 0 9.28 0.736 11.872 2.144a14.528 14.528 0 0 1 6.08 6.048c1.376 2.592 2.112 5.28 2.112 11.872V800h-48V372.064c0-6.592 0.736-9.28 2.144-11.872a14.528 14.528 0 0 1 6.048-6.08c2.592-1.376 5.28-2.112 11.872-2.112z" fill="#FFFFFF" p-id="29296"></path><path d="M576 220.832a24 24 0 0 1 2.816-11.264l1.216-2.048a24 24 0 0 1 31.296-7.84l1.984 1.184 188.448 157.632a32 32 0 0 1 14.144 24l0.096 2.624V768a32 32 0 0 1-29.6 31.904L784 800H576V220.8z m167.36 419.2h-14.72a9.44 9.44 0 0 0-4.544 1.024 7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544v62.72a9.44 9.44 0 0 0 1.024 4.544c0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024h14.72a9.44 9.44 0 0 0 4.544-1.024 7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544v-62.72a9.44 9.44 0 0 0-1.024-4.544 7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024z m-80 0h-14.72a9.44 9.44 0 0 0-4.544 1.024 7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544v62.72a9.44 9.44 0 0 0 1.024 4.544c0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024h14.72a9.44 9.44 0 0 0 4.544-1.024 7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544v-62.72a9.44 9.44 0 0 0-1.024-4.544 7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024z m80-144h-14.72a9.44 9.44 0 0 0-4.544 1.024 7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544v62.72a9.44 9.44 0 0 0 1.024 4.544c0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024h14.72a9.44 9.44 0 0 0 4.544-1.024 7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544v-62.72a9.44 9.44 0 0 0-1.024-4.544 7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024z m-80 0h-14.72a9.44 9.44 0 0 0-4.544 1.024 7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544v62.72a9.44 9.44 0 0 0 1.024 4.544c0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024h14.72a9.44 9.44 0 0 0 4.544-1.024 7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544v-62.72a9.44 9.44 0 0 0-1.024-4.544 7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024z m0-144h-14.72a9.44 9.44 0 0 0-4.544 1.024 7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544v62.72a9.44 9.44 0 0 0 1.024 4.544c0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024h14.72a9.44 9.44 0 0 0 4.544-1.024 7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544v-62.72a9.44 9.44 0 0 0-1.024-4.544 7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024zM443.968 207.52c2.56 3.84 3.968 8.32 4.032 12.928L447.968 800 240 800a32 32 0 0 1-32-32V385.12a32 32 0 0 1 14.24-26.624l188.448-157.632a24 24 0 0 1 33.28 6.656zM282.24 640c-3.552 0-4.832 0.384-6.144 1.056a7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544L272 709.76c0 3.552 0.384 4.832 1.056 6.144 0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024l13.12 0.032c3.552 0 4.832-0.384 6.144-1.056a7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544l0.032-61.12c0-3.552-0.384-4.832-1.056-6.144a7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024L282.24 640z m80 0c-3.552 0-4.832 0.384-6.144 1.056a7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544L352 709.76c0 3.552 0.384 4.832 1.056 6.144 0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024l13.12 0.032c3.552 0 4.832-0.384 6.144-1.056a7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544L384 650.24c0-3.552-0.384-4.832-1.056-6.144a7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024L362.24 640z m-80-144c-3.552 0-4.832 0.384-6.144 1.056a7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544L272 565.76c0 3.552 0.384 4.832 1.056 6.144 0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024l13.12 0.032c3.552 0 4.832-0.384 6.144-1.056a7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544l0.032-61.12c0-3.552-0.384-4.832-1.056-6.144a7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024l-13.12-0.032z m80 0c-3.552 0-4.832 0.384-6.144 1.056a7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544L352 565.76c0 3.552 0.384 4.832 1.056 6.144 0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024l13.12 0.032c3.552 0 4.832-0.384 6.144-1.056a7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544L384 506.24c0-3.552-0.384-4.832-1.056-6.144a7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024l-13.12-0.032z m0-144c-3.552 0-4.832 0.384-6.144 1.056a7.264 7.264 0 0 0-3.04 3.04 9.44 9.44 0 0 0-1.024 4.544L352 421.76c0 3.552 0.384 4.832 1.056 6.144 0.704 1.28 1.728 2.336 3.04 3.04 1.088 0.576 2.176 0.928 4.544 1.024l13.12 0.032c3.552 0 4.832-0.384 6.144-1.056a7.264 7.264 0 0 0 3.04-3.04 9.44 9.44 0 0 0 1.024-4.544L384 362.24c0-3.552-0.384-4.832-1.056-6.144a7.264 7.264 0 0 0-3.04-3.04 9.44 9.44 0 0 0-4.544-1.024L362.24 352z" fill="#FFFFFF" fill-opacity=".7" p-id="29297"></path><path d="M64 737.696l0.16 10.784 0.576 14.496 0.576 8.64c1.696 20.704 4.928 34.304 9.6 45.92l1.856 4.256 2.08 4.384 2.24 4.352c9.92 18.56 23.936 33.536 41.6 44.48l6.784 3.904 4.32 2.24 4.384 2.08c11.872 5.344 25.216 9.088 46.176 11.072l8.256 0.64 8.992 0.544 9.92 0.32 16.544 0.192h573.632l10.784-0.192 14.496-0.576 8.64-0.576c20.704-1.664 34.304-4.928 45.92-9.6l4.256-1.824 4.384-2.08 4.352-2.24a116.064 116.064 0 0 0 44.48-41.6l3.904-6.784 2.24-4.352 2.08-4.384c5.344-11.84 9.088-25.216 11.072-46.176l0.64-8.224 0.544-9.024 0.32-9.888L960 736v59.904l-0.192 16.576-0.32 9.888-0.512 9.024c-1.76 25.824-5.76 41.056-11.744 54.4l-2.08 4.384-2.24 4.352a116.32 116.32 0 0 1-48.384 48.384l-4.352 2.24-4.384 2.08c-12.608 5.664-26.88 9.536-50.208 11.424l-13.216 0.832-9.888 0.32-10.784 0.16L228.064 960l-16.576-0.192-9.888-0.32-8.992-0.512c-25.856-1.76-41.088-5.76-54.4-11.744l-4.416-2.08-4.32-2.24a116.32 116.32 0 0 1-48.384-48.384l-2.24-4.352-2.08-4.384c-5.696-12.608-9.568-26.88-11.456-50.208l-0.576-8.608-0.224-4.608-0.32-9.888L64 801.696v-64z" fill="#000000" fill-opacity=".08" p-id="29298"></path></svg>
        </div>
        <div class="text-info">
          <div class="info">
            <span class="name">{{ item.name }}</span>
            <span class="action">{{ item.action }}</span>
          </div>
          <p class="timestamp">{{ item.time | formaterTime }}</p>
        </div>
        <div class="timeline" v-if="data.length > 1"></div>
        <div class="timeline-point"></div>
      </div>
    </template>
    <template v-else>
      <div>
        <el-empty description="暂无任何动态"></el-empty>
      </div>
    </template>
  </div>
</template>
<script>
import {Empty} from "element-ui";
/**
 * @description 工单动态
 */
export default {
  name: 'OrderDynamic',
  components:{
    'el-empty': Empty
  },
  props: {
    taskTodo: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data(){
    return {
      data: [],
    }
  },
  filters: {
    formaterTime(v) {
      if(typeof v === 'string') {
        const date = v.substring(0, 16)
        return date.replaceAll('-', '/')
      } else {
        return '/'
      }
    }
  },
  mounted() {
    this.initData()
  },
  watch:{
    taskTodo: {
      handler(){
        this.initData()
      },
      deep:true
    }
  },
  methods:{
    initData(){
      const dynamic = []
      for (let item of this.taskTodo){
        for (let user of item.user_task){
          if(user.is_deal === 1){
            let itemData = {
              time: user.updated_at,
              title: '1#',
              action: '处理了任务：' + item.name,
              name: user.user_name
            }
            dynamic.push(itemData)
          }
        }
      }
      this.data = dynamic
    },
  },
}
</script>
<style lang="less" scoped>
  .dynamic-container{
    width: 100%;
    height: 100%;
    padding: 0 5px;
    box-sizing: border-box;
    .dynamic-item{
      position: relative;
      display: flex;
      padding: 0 70px 0 0;
      border-radius: 4px;
      .avatar{
        margin: 16px 12px 0 16px;
        height: 32px;
        width: 32px;
      }
      .text-info{
        padding: 16px 0;
        box-sizing: border-box;
        flex-grow: 1;
        .info{
          .name{
            height: 22px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3F548F;
            line-height: 22px;
          }
          .action{
            margin-left: 12px;
            height: 22px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2A2F3D;
            line-height: 22px;
          }
        }
        .timestamp {
          margin-top: 4px;
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #787E8F;
          line-height: 22px;
        }
      }
      .timeline-point{
        width: 8px;
        height: 8px;
        position: absolute;
        right: 32px;
        top: calc(50% - 4px);
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #2A2F3D;
        box-sizing: border-box;
      }
      .timeline{
        position: absolute;
        width: 0;
        right: 35px;
        height: 100%;
        border-left: 2px solid #E6E9ED;
        box-sizing: border-box;
      }
      &:hover{
        background: #F2F4F8;
      }
    }
    & > .dynamic-item {
      &:first-child{
        .timeline{
          top: 50%;
          height: 50%;
        }
        .timeline-point{
          background: var(--themeThreeColor);
          border:none;
        }
      }
      &:last-child{
        .timeline{
          top: 0%;
          height: 50%;
        }
      }
    }
  }
</style>
